import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/Warning.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "Transmision_title" }, "Modificación de transmisión", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, [
  /*#__PURE__*/_createTextVNode(" Navega por las pestañas y modifica la información de los campos que requieras sobre la nómina transmitida de tu empleado, una vez finalizados los cambios haz clic en el botón "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Transmitir")
  ]),
  /*#__PURE__*/_createTextVNode(" para confirmar las modificaciones. ")
], -1)
const _hoisted_3 = { class: "button-position botonera" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "PopUpVideo_video"
}
const _hoisted_6 = {
  id: "video",
  class: "PopUpVideo_video_player",
  controls: "",
  ref: "VideoNominaAjustePortal"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-header-close-icon pi pi-times" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "60",
  height: "60",
  alt: "Alerta"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Presentas algunos errores en la validación, al seleccionar el campo podrás tener mayor información, por favor realiza los ajustes para continuar con la transmisión. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "80",
  height: "80",
  style: {"margin-right":"25px"},
  alt: "Alerta"
}, null, -1)
const _hoisted_13 = { class: "flex p-4" }
const _hoisted_14 = {
  class: "pl-2 gray-text",
  style: {"text-align":"justify"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Transmitir")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Volver")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ResumenEmpleado = _resolveComponent("ResumenEmpleado")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_LiquidacionNomina = _resolveComponent("LiquidacionNomina")!
  const _component_center = _resolveComponent("center")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_DeduccionesNomina = _resolveComponent("DeduccionesNomina")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TransmitirNomina = _resolveComponent("TransmitirNomina")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "Button_BColorDegraded btn-position",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.ValidarInformacion && $setup.ValidarInformacion(...args))),
        id: "transmission-size"
      }, "Transmitir "),
      _createElementVNode("a", {
        class: "btn-back btn-position",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.GoToSummary && $setup.GoToSummary(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'arrow-left'],
          size: "xs"
        }),
        _createTextVNode(" Volver ")
      ])
    ]),
    ($setup.empleado && $setup.detalle)
      ? (_openBlock(), _createBlock(_component_ResumenEmpleado, {
          key: 0,
          empleado: $setup.empleado,
          detalle: $setup.detalle,
          fechaIngreso: $setup.fechaIngreso,
          fechaAprobacion: $setup.fechaAprobacion,
          id: "pt-summmary"
        }, null, 8, ["empleado", "detalle", "fechaIngreso", "fechaAprobacion"]))
      : _createCommentVNode("", true),
    ($setup.featureFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btnPopUpPayRollColor btnPopUpPayRoll",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.visiblePopUpIndividual = true))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'play-circle'],
              size: "sm"
            }),
            _createTextVNode(" Mira cómo se hace ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: $setup.visiblePopUpIndividual,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.visiblePopUpIndividual) = $event)),
      width: "60%",
      higth: "30%",
      top: "",
      closable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("button", {
          class: "p-dialog-header-icon p-dialog-header-close p-link",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.detenerVideo && $setup.detenerVideo(...args))),
          style: {"margin-left":"95%"}
        }, _hoisted_9)
      ]),
      default: _withCtx(() => [
        ($setup.urlvd != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("video", _hoisted_6, [
                _createElementVNode("source", {
                  src: $setup.urlvd,
                  type: "video/mp4"
                }, null, 8, _hoisted_7)
              ], 512)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_TabView, { activeIndex: $setup.activeTab }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Liquidación de nómina" }, {
          default: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createVNode(_component_LiquidacionNomina, {
                  class: "pt-tabpanel",
                  nomina: $setup.scopeNomina
                }, null, 8, ["nomina"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Otros devengos y deducciones" }, {
          default: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createVNode(_component_DeduccionesNomina, {
                  class: "pt-tabpanel",
                  nomina: $setup.scopeNomina
                }, null, 8, ["nomina"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex"]),
    _createVNode(_component_Dialog, {
      visible: $setup.error,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (($setup.error) = $event)),
      modal: "",
      closable: false,
      header: "Error",
      draggable: false,
      id: "p-dialog",
      class: "error-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          onClick: $setup.CerrarModal,
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("← Volver")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_10,
        _hoisted_11
      ]),
      _: 1
    }, 8, ["visible"]),
    ($setup.store.state.Transmitir && $setup.nominaEmpleado)
      ? (_openBlock(), _createBlock(_component_TransmitirNomina, {
          key: 2,
          empleadoId: $setup.empleadoId,
          nominaEmpleado: $setup.nominaEmpleado
        }, null, 8, ["empleadoId", "nominaEmpleado"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, {
      id: "confirm-dialog",
      draggable: false
    }, {
      message: _withCtx((props) => [
        _createTextVNode(_toDisplayString(props.message.message) + " ", 1),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, [
            _createTextVNode(" Estás a punto de realizar un ajuste que modifica la información transmitida para la nómina del periodo "),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString($setup.periodo), 1)
            ]),
            _createTextVNode(" de "),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString($setup.empleado.nombres) + " " + _toDisplayString($setup.empleado.apellidos), 1)
            ]),
            _createTextVNode(" identificado con el documento "),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString($setup.empleado.tipoIdentificacion) + ":" + _toDisplayString($setup.empleado.numeroIdentificacion), 1)
            ]),
            _createTextVNode(", en caso de estar seguro de la información registrada y los valores totales de la nómina, haz clic en el botón "),
            _hoisted_15,
            _createTextVNode(", de lo contrario haz clic en el botó "),
            _hoisted_16,
            _createTextVNode(". ")
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}